import InsulationFilter from './filters/InsulationFilter.js';
import ClassFilter from './filters/ClassFilter.js';
//import SoundFilter from './filters/SoundFilter.js';
import WhiteGlassFilter from './filters/WhiteGlassFilter.js';
import ButtJointsFilter from './filters/ButtJointsFilter.js';
import ManofacturerFilter from './filters/ManofacturerFilter.js';
import StructureFilter from './filters/StructureFilter.js';
import ApplicationFilter from './filters/ApplicationFilter.js';
import ResistanceFilter from './filters/ResistanceFilter.js';

export default class FilterHandler 
{
  constructor() 
  {
    this.filters = {};
    this.snapshots = [];
    this.userModified = {};

    // we instantiate all the filters
    this.classFilter = new ClassFilter(this, '.class');
    //this.soundFilter = new SoundFilter(this, ".sound");
    this.clearGlassFilter = new WhiteGlassFilter(this, '.white-glass');
    this.buttJointsFilter = new ButtJointsFilter(this, '.butt-joints');
    this.manofacturerFilter = new ManofacturerFilter(this, '.manufacturer');
    this.applicationFilter = new ApplicationFilter(this, '.application');
    this.resistanceFilter = new ResistanceFilter(this, '.resistance');
      
    this.structureFilter = new StructureFilter(this,'.structure');
    this.insulationFilter = new InsulationFilter(this,'.insulation');
  }

  setup()
  {
    this.applicationFilter.select_dropdown_option('Inside');
    this.insulationFilter.select_dropdown_option('U-Wert 5.4');
    this.structureFilter.select_dropdown_option('1-glazed (mono)');
    this.classFilter.select_dropdown_option('EI30');
  }

  run_filter() 
  {
    this.uiHandler.run_filter();
  }

  select_dropdown_option_mg(id) 
  {
    this.uiHandler.select_dropdown_option_mg(id);
  }
  select_dropdown_option_og(id) 
  {
    this.uiHandler.select_dropdown_option_og(id);
  }
  set_s1_s2(s1,s2,g1,g2) 
  {
    this.uiHandler.set_s1_s2(s1,s2,g1,g2);
  }
  set_uv(uv) 
  {
    this.uiHandler.set_uv(uv);
  }

  add(filter, name) 
  {
    this.filters[name] = filter;
  }

  get(name) 
  {
    if(this.filters[name]) 
    {
      return this.filters[name];
    }
    else 
    {
      console.error('filter has not been created just yet');
    }
  }

  run(frg, middglass, outsideglass) 
  {
    const ctx = this;
    Object.keys(this.filters).forEach((key,index) => 
    {
      ctx.filters[key].run(
        frg,
        middglass,
        outsideglass
      );
    });
  }

  getSnapshop() 
  {
    // a snapshop is the status of all the filters at a given time
    let snapshop = {};
    Object.keys(this.filters).forEach(((key,index) => 
    {
      snapshop[key] = this.filters[key].activeFilterName();
    }).bind(this));

    return snapshop;
  }

  takeSnapshot(filterName) 
  {
    let snapshop = this.getSnapshop();
    
    this.snapshots.push(snapshop);
    this.userModified[filterName] = true;

    let snap_length = this.snapshots.length;
    if (snap_length > 1) 
    {
      const previous = this.snapshots[snap_length - 2];
      const current = this.snapshots[snap_length - 1];

      const difference = [];

      Object.keys(this.filters).forEach(((key,index) => 
      {
        if (key === filterName) return;

        if (current[key] !== previous[key] && this.userModified[key]) 
        {
          difference.push(key);
          this.userModified[key] = false;
        }
      }).bind(this));

      if(difference.length > 0)
      {
        this._showCascadeToast(difference);
      }
    }
  }

  callback()
  {
    const ctx = this;
    Object.keys(this.filters).forEach((key,index) =>
    {
      ctx.filters[key].callback();
    });
  }

  _showCascadeToast(affectedFilters)
  {
    const FILTER_LABELS = {
      'StructureFilter': 'Aufbau',
      'ClassFilter': 'Brandschutzklasse',
      'InsulationFilter': 'Isolation',
      'ManofacturerFilter': 'Hersteller',
      'ApplicationFilter': 'Anwendung',
      'WhiteGlassFilter': 'Weissglas',
      'ResistanceFilter': 'Widerstandsklasse',
      'ButtJointsFilter': 'Stossfugen'
    };

    const labels = affectedFilters.map(f => FILTER_LABELS[f] || f).join(', ');
    const toast = document.getElementById('cascade-toast');
    const textEl = document.getElementById('cascade-toast-text');

    if (!toast || !textEl) return;

    textEl.textContent = labels + ' wurde automatisch angepasst';

    // Clear any existing timer
    if (this._toastTimer) clearTimeout(this._toastTimer);

    toast.classList.add('visible');

    // Tap toast to scroll properties to top and dismiss
    toast.onclick = () => {
      const colLeft = document.querySelector('.col-left');
      if (colLeft) colLeft.scrollTo({ top: 0, behavior: 'smooth' });
      toast.classList.remove('visible');
    };

    this._toastTimer = setTimeout(() => {
      toast.classList.remove('visible');
    }, 3500);
  }

}

